<template>
	<el-dialog class="change-password-dialog" title="修改密码" :visible="show" :close-on-click-modal="false" width="450px" @close="closeDialog">
		<el-form ref="vForm" class="form" :model="vForm" :rules="rules" size="medium">
			<el-form-item class="form-group" prop="old_password">
				<el-input v-model="vForm.old_password" type="text" class="form-control" clearable auto-complete="off" placeholder="请填写原密码" />
			</el-form-item>
			<el-form-item class="form-group" prop="password">
				<el-input v-model="vForm.password" type="password" class="form-control" show-password auto-complete="new-password" placeholder="密码需6-16位" />
			</el-form-item>
			<el-form-item class="form-group" prop="password_check">
				<el-input v-model="vForm.password_check" type="password" class="form-control" show-password auto-complete="new-password" placeholder="请确认新密码" />
			</el-form-item>
		</el-form>
		<div slot="footer" class="dialog-footer">
			<el-button size="small" @click="closeDialog">取 消</el-button>
			<el-button ref="btn" type="primary" :loading="doSubmitLoading" size="small" @click="doSubmit()">
				确 定
			</el-button>
		</div>
	</el-dialog>
</template>

<script>
	export default {
		props: {
			show:{
				type:Boolean,
				default:false
			}
		},
		data() {
			let passwordCheck = (rule, value, callback) => {
				if (value === "") {
					callback(new Error("新密码必填"));
				}
				let reg = /.{6,16}/;
				if (!reg.test(value)) {
					callback(new Error("密码需6-16位"));
				} else {
					callback();
				}
			};
			let password2Check = (rule, value, callback) => {
				if (value === "") {
					callback(new Error("确认密码必填"));
				}
				if (value !== this.vForm.password) {
					callback(new Error("两次密码不一致，请重新填写"));
				} else {
					callback();
				}
			};
			return {
				doSubmitLoading: false,
				vForm: {
					old_password: "",
					password: "",
					password_check: ""
				},
				rules: {
					old_password: {
						required: true,
						message: "原密码必填",
						trigger: "blur"
					},
					password: {validator: passwordCheck, trigger: "blur"},
					password_check: {validator: password2Check, trigger: "blur"}
				}
			};
		},
		methods: {
			closeDialog() {
				this.$emit("update:show", false);
			},
			async doSubmit() {
				this.doSubmitLoading = true;
				try {
					await this.$refs.vForm.validate();
					await this.api[this.config.WEB == 1 ? "userAdmin" : "user"].updatePwd(
						this.vForm
					);
					this.closeDialog();
					this.$message.success("修改成功");
				} catch (e) {
					console.error(e);
				}
				this.doSubmitLoading = false;
			}
		}
	};
</script>

<style lang="scss"></style>
